import React from 'react'
import { useRouteError } from 'react-router-dom'

import { Dialog } from '@frame/components/dialog'
import { ErrorContent } from '@frame/components/screens/non-terminal/error/error-content'
import * as errors from '@frame/lib/errors'
import { useStore } from '@frame/lib/stores/useStore'

export function ErrorBoundary() {
  // error boundary to be used with react-router
  const rawError = useRouteError()

  const setError = useStore((state) => state.setError)
  const error = errors.getErrorWithFallback(rawError, new Error(JSON.stringify(rawError)))
  const internalError = errors.create({
    error,
    code: errors.codes.Error,
    setError,
  })

  return (
    <Dialog>
      <ErrorContent error={internalError} />
    </Dialog>
  )
}
